import { FC, PropsWithChildren } from "react";

export type IndustrySectionTab = "industry" | "position";

interface Props {
    onChangeTabType: (value: IndustrySectionTab) => void;
    activeTab: IndustrySectionTab;
}

const IndustryTabs: FC<PropsWithChildren & Props> = ({ children, onChangeTabType, activeTab }) => {
    return (
        <>
            <div>
                <div className="box">
                    <ul className="nav nav-boxed-tabs mt-8" role="tablist">
                        <li className="nav-item flex-1" role="presentation">
                            <button
                                className={`nav-link w-full py-2 ${activeTab === "industry" ? "active" : ""}`}
                                data-tw-toggle="pill"
                                type="button"
                                role="tab"
                                aria-selected={activeTab === "industry"}
                                onClick={() => onChangeTabType("industry")}
                            >
                                Industry
                            </button>
                        </li>
                        <li className="nav-item flex-1" role="presentation" onClick={() => onChangeTabType("position")}>
                            <button
                                className={`nav-link w-full py-2 ${activeTab === "position" ? "active" : ""}`}
                                data-tw-toggle="pill"
                                type="button"
                                role="tab"
                                aria-selected={activeTab === "position"}
                            >
                                Position
                            </button>
                        </li>
                    </ul>
                </div>
                <div className="tab-content mt-5">{children}</div>
            </div>
        </>
    );
};

export default IndustryTabs;
